module.exports = __webpack_public_path__ + "static/media/microblog-h5.cec8f965.png";